const { BLAZE_IGNORE_ERRORS, BLAZE_ERROR_SEPARATOR } = require('../constants');

// errorRepresentative can be error.value/error.message/error.type
const doNotSendError = errorRepresentative => {
  if (!errorRepresentative) return false;

  const errorList = getEnvironmentErrorList('BLAZE_IGNORE_ERRORS', BLAZE_IGNORE_ERRORS);
  const errorRegex = errorList.map(regex => new RegExp(`${regex}$`));
  return !!errorRegex.find(regex => errorRepresentative.match(regex));
};

function getEnvironmentErrorList(environmentKey, defaultValue) {
  const errors = process.env[environmentKey] || defaultValue || '';
  if (!errors) return [];

  return errors.split(BLAZE_ERROR_SEPARATOR).filter(regex => !!regex);
}

function getDefaultEnvironment(environmentConstValue) {
  // environmentConstValue is comming from defined constant for the monitor plugin.
  return process.env.BLAZE_MONITOR_ENVIRONMENT || environmentConstValue;
}

module.exports = {
  doNotSendError,
  getDefaultEnvironment,
  getEnvironmentErrorList
};
